var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTablesHeader = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.2 5.1H6.9c-1 0-1.8.8-1.8 1.8v12.3c0 1 .8 1.8 1.8 1.8h12.3c1 0 1.8-.8 1.8-1.8V6.9c0-1-.8-1.8-1.8-1.8m1.1 1.8v3.7h-9V5.8h7.9c.6 0 1.1.5 1.1 1.1M6.9 5.8h3.7v4.8H5.8V6.9c0-.6.5-1.1 1.1-1.1M5.8 19.2v-7.9h4.8v9H6.9c-.6 0-1.1-.5-1.1-1.1m13.4 1.1h-7.9v-9h9v7.9c0 .6-.5 1.1-1.1 1.1"
})));
export default SvgTablesHeader;